export default "__VITE_ASSET__B15MGg9s__"